import { initGraphQLTada } from 'gql.tada'
import { GraphQLClient } from 'graphql-request'

import {
  create_graphql_call,
  create_graphql_multi_call,
} from '../helpers/utilities.ts'

import type { introspection } from './subgraph_telemetry_schema_graphql_env.d.ts'

export const graphql = initGraphQLTada<{
  introspection: introspection
  scalars: {
    BigDecimal: string
    BigInt: string
    ID: string
    Timestamp: string
  }
}>()

export const server_client = new GraphQLClient(
  import.meta.env.VITE_SUBGRAPH_KEY
    ? `https://api.goldsky.com/api/public/project_cmgzmvxi700dr5np2610jaipx/subgraphs/telemetry-${import.meta.env.VITE_SUBGRAPH_ENV}/latest/gn`
    : 'http://localhost/graphql',
)
export const graphql_call = create_graphql_call(server_client)

export const graphql_multi_call = create_graphql_multi_call(server_client)
